import { render, staticRenderFns } from "./TextAreaDrawer.vue?vue&type=template&id=f6bfa340&scoped=true&"
import script from "./TextAreaDrawer.vue?vue&type=script&lang=ts&"
export * from "./TextAreaDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaDrawer.vue?vue&type=style&index=0&id=f6bfa340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bfa340",
  null
  
)

export default component.exports